import axios from 'axios'
import { baseURL } from '@/config'
import router from '@/router/index'
import { getLocal, setLocal } from '@/utils/utils'
// import Toast from '@/components/Toast'
import Vue from 'vue';
import store from "@/store";
import { Toast } from 'vant';
Vue.use(Toast)

// 创建axios实例
const service = axios.create({
  async: true,
  crossDomain: true,
  withCredentials: true,
  baseURL: baseURL,
  timeout: 15000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {
  // alert(config.path)
  if (getLocal('m-token')) {
    config.headers['token'] = getLocal('m-token')
  }
  // console.log(config)
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    const token = getLocal('m-token')
    // let $route = (router.app && router.app._route) || {}
    if (res.code === undefined) return res
    if (res.code !== 0) {
      if (res.code !== -3) {
        Toast(res.msg || '请求发生错误')
      }
      // 未登录;
      if (res.code === -3) {
        if (token) {
          Toast('登录已过期')
        } else {
          router.replace({ path: '/login' })
        }
        setLocal('m-token', '')
        store.dispatch('user/checkLogin')
          .then(() => { })
          .catch(() => { })
        // router.replace({ path: '/login' })
        // Toast(res.msg || '请求发生错误')
      }
      return Promise.reject(res)
    } else {
      return res.data
    }
  },
  error => {
    Toast('网络错误')
    return Promise.reject(error)
  }
)

export default service
